export const iconFontAwesomeMarketingShip = (
	<i className="fa-solid fa-ship"></i>
);
